// extracted by mini-css-extract-plugin
module.exports = {"boxNoteColor":"_2Ygq9Tp7fv2m92ECRT1PFP","boxDate":"_2ZGI-Znu8cB7MhV6y2aeIc","boxNoteDisable":"_1oUlTvTkO9tKBpGylEPsuI","date":"YQOi8Ci8cfUWJmTatYQ9U"};